<footer class="login-footer">
    <nav>
        <div class="container">
            <p class="text-center" id="footer-text-copyright">© {{ currentYear }} Octopus Interactive</p>
        </div>
    </nav>
</footer>
